module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 col-12 p-0"
  }, [_c('div', {
    staticClass: "col-12 row mx-0 px-3 py-2",
    staticStyle: {
      "background-image": "linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123))",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][1]))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "font-size": "15px",
      "border-radius": "5px"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][13]))])])], 1)]), _vm._v(" "), (_vm.serial.startsWith('KH2')) ? _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)",
      "font-size": "1.2rem",
      "font-weight": "bold"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v(" " + _vm._s(_vm.msglist[_vm.$route.params.language][15]) + " "), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Calmode),
      expression: "Calmode"
    }],
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "name": "Calmode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Calmode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][16]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][17]))])]), _vm._v(" "), (_vm.Calmode == '0') ? _c('div', {
    staticClass: "col-12 px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][19]))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Calmode == '1') ? _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)",
      "font-size": "1.2rem"
    }
  }, [_c('div', {
    staticClass: "col-12 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][7]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 mt-2"
  }, [_c('div', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "col px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][11]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 mt-2"
  }, [_c('div', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "col px-0",
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][21]) + ".")])])]) : _vm._e(), _vm._v(" "), (_vm.Calmode == '0') ? _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)",
      "font-size": "1.2rem"
    }
  }, [_c('div', {
    staticClass: "col-12 row mx-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][20]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][7]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0"
  }, [_c('div', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "col px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][8]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 mt-2"
  }, [_c('div', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "col px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][9]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 mt-2"
  }, [_c('div', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('div', {
    staticClass: "col px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][10]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 mt-2"
  }, [_c('div', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("4.")]), _vm._v(" "), _c('div', {
    staticClass: "col px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][11]))])]), _vm._v(" "), (_vm.serial.startsWith('KH2')) ? _c('div', {
    staticClass: "col-12 row mx-0 mt-2"
  }, [_c('div', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "col px-0",
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][21]) + ".")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 mt-2"
  }, [_c('div', {
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("5.")]), _vm._v(" "), _c('div', {
    staticClass: "col px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][12]) + ".")])])]) : _vm._e(), _vm._v(" "), (_vm.Calmode == '0') ? _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][2]))]), _vm._v(" "), _c('div', {
    staticClass: "px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trueKH),
      expression: "trueKH"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "min": "0",
      "max": "20",
      "step": "0.1",
      "type": "number",
      "name": "TrueTankKH_value"
    },
    domProps: {
      "value": (_vm.trueKH)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.trueKH = $event.target.value
      }, _vm.limitKH]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("dKH")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 pb-2"
  }, [_vm._v(" " + _vm._s(_vm.msglist[_vm.$route.params.language][18]) + " ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-3 mb-1 justify-content-center",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [(_vm.name !== 'khacra') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "name": "TrueTankKH_button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][3]))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-auto",
    staticStyle: {
      "color": "red"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.message1))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "65px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e53c54"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KH_calibration.vue
// module id = 354
// module chunks = 0